import { ModalBody, ModalHeader } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { ImageModel } from "../../../../api-clients/product-api-v1"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import { CustomModalPropTypes } from "../../../../common/types/useModal"
import MenuFilter from "../../../shared/MenuFilter"
import { GalleryInModal } from "./GalleryInModal"

type Props = {
  Modal: (arg0: CustomModalPropTypes) => JSX.Element
  isOpen: boolean
  onClose: () => void
  title: string
  articleData: { name: string; images: ImageModel[]; id: string }[]
  activeSlide: number
  activeArticleId?: string
  setActiveArticleId?: (arg0: string) => void
  isArchived?: boolean
}

const GalleryModal = ({
  Modal,
  isOpen,
  onClose,
  title,
  articleData,
  activeSlide,
  activeArticleId,
  setActiveArticleId,
  isArchived,
}: Props) => {
  const { t } = useBrandedTranslation()

  const getSelectedArticleIndex = () => {
    return activeArticleId ? articleData.findIndex((item) => item.id === activeArticleId) : 0
  }

  const [selectedArticleInd, setSelectedArticleInd] = useState<number>(getSelectedArticleIndex())

  useEffect(() => {
    setSelectedArticleInd(getSelectedArticleIndex())
  }, [isOpen, activeArticleId])

  const onMenuChange = (value: string) => {
    setSelectedArticleInd(articleData.findIndex((article) => article.name === value))
  }

  const handleClose = () => {
    // Reset the internal state of the modal
    setActiveArticleId?.("")
    setSelectedArticleInd(0)

    onClose()
  }

  // Normalize data for MenuFilter component
  const menuOptions = articleData.map((article) => {
    return {
      name: article.name,
      value: article.name,
    }
  })

  return (
    <Modal
      isOpen={isOpen}
      customOnClose={handleClose}
      modalContentStyleProps={{
        p: "8",
        m: { base: "6", md: "16" },
        maxW: "6xl",
        minH: "fit-content",
        borderRadius: "0",
      }}
    >
      <ModalHeader p="0" my="4" pr="8" fontWeight="medium">
        {title}
      </ModalHeader>

      <ModalBody p="0">
        <MenuFilter
          menuOptions={menuOptions}
          selectedOption={menuOptions[selectedArticleInd].value}
          menuTitle={t("filter-images-by-article")}
          handleSelect={onMenuChange}
        />
        <GalleryInModal
          images={articleData[selectedArticleInd].images}
          activeSlide={activeArticleId && !isArchived ? 0 : activeSlide}
          selectedArticleInd={selectedArticleInd}
          isArchived={isArchived}
        />
      </ModalBody>
    </Modal>
  )
}

export default GalleryModal
